import React, { useState } from 'react';
import { Send, Phone } from 'lucide-react';
import { companyInfo } from '../mock';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LeadForm = ({ title = "Get Your Free Quote", subtitle = "Fill out the form and a pest professional will contact you shortly", source = "unknown" }) => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    service: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const response = await axios.post(`${API}/leads`, {
        ...formData,
        source: source
      });
      
      if (response.data) {
        toast.success('Quote request submitted! A pest professional will contact you shortly.');
        setFormData({ name: '', phone: '', email: '', service: '', message: '' });
      }
    } catch (error) {
      console.error('Error submitting lead:', error);
      toast.error('Something went wrong. Please call us directly at ' + companyInfo.phone);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="product-card">
      <h3 className="heading-2 mb-2">{title}</h3>
      <p className="body-medium mb-6" style={{ color: 'var(--text-secondary)' }}>
        {subtitle}
      </p>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="body-small font-semibold block mb-2" style={{ color: 'var(--text-primary)' }}>
            Full Name *
          </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            className="w-full px-4 py-3 rounded-lg border focus:outline-none focus:ring-2 focus:ring-accent-primary"
            style={{ borderColor: 'var(--border-light)' }}
            placeholder="John Smith"
          />
        </div>
        
        <div>
          <label className="body-small font-semibold block mb-2" style={{ color: 'var(--text-primary)' }}>
            Phone Number *
          </label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            required
            className="w-full px-4 py-3 rounded-lg border focus:outline-none focus:ring-2 focus:ring-accent-primary"
            style={{ borderColor: 'var(--border-light)' }}
            placeholder="(555) 123-4567"
          />
        </div>
        
        <div>
          <label className="body-small font-semibold block mb-2" style={{ color: 'var(--text-primary)' }}>
            Email
          </label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full px-4 py-3 rounded-lg border focus:outline-none focus:ring-2 focus:ring-accent-primary"
            style={{ borderColor: 'var(--border-light)' }}
            placeholder="john@example.com"
          />
        </div>
        
        <div>
          <label className="body-small font-semibold block mb-2" style={{ color: 'var(--text-primary)' }}>
            Service Needed *
          </label>
          <select
            name="service"
            value={formData.service}
            onChange={handleChange}
            required
            className="w-full px-4 py-3 rounded-lg border focus:outline-none focus:ring-2 focus:ring-accent-primary"
            style={{ borderColor: 'var(--border-light)' }}
          >
            <option value="">Select a service...</option>
            <option value="inspection">Pest Inspection</option>
            <option value="rats-mice">Rats & Mice</option>
            <option value="bed-bugs">Bed Bugs</option>
            <option value="cockroaches">Cockroaches</option>
            <option value="ants">Ants</option>
            <option value="fleas-mites">Fleas or Mites</option>
            <option value="hornets-wasps">Hornets & Wasps</option>
            <option value="spiders">Spiders</option>
            <option value="flies">Flies</option>
            <option value="bees">Bees</option>
            <option value="bird-proofing">Bird Proofing</option>
            <option value="mosquitoes">Mosquitoes</option>
            <option value="termites">Termites</option>
            <option value="wildlife">Wildlife Removal</option>
            <option value="airbnb">Airbnb Pest Control</option>
            <option value="other">Other</option>
          </select>
        </div>
        
        <div>
          <label className="body-small font-semibold block mb-2" style={{ color: 'var(--text-primary)' }}>
            Message
          </label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            rows="3"
            className="w-full px-4 py-3 rounded-lg border focus:outline-none focus:ring-2 focus:ring-accent-primary"
            style={{ borderColor: 'var(--border-light)' }}
            placeholder="Tell us about your pest problem..."
          />
        </div>
        
        <button type="submit" className="btn-primary w-full" disabled={isSubmitting}>
          <Send size={20} />
          {isSubmitting ? 'Submitting...' : 'Request Free Quote'}
        </button>
        
        <div className="text-center pt-2">
          <p className="body-small mb-2" style={{ color: 'var(--text-secondary)' }}>Or call us directly:</p>
          <a href={`tel:${companyInfo.phoneRaw}`} className="flex items-center justify-center gap-2 font-semibold" style={{ color: 'var(--accent-text)' }}>
            <Phone size={18} />
            {companyInfo.phone}
          </a>
        </div>
      </form>
    </div>
  );
};

export default LeadForm;
